import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Capturar el evento beforeinstallprompt a nivel de ventana para que ningún componente lo pierda
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPWAInstallPrompt = e;
  });
}

// Detección estricta de entorno nativo / local vs PWA en producción web
const isNativeApp = typeof window !== 'undefined' && (
  !!(window.Capacitor?.isNativePlatform?.()) ||
  !!window.Capacitor ||
  window.location.protocol === 'capacitor:' ||
  window.location.hostname === 'localhost'
);
const isPWAProduction = process.env.NODE_ENV === 'production' && window.location.hostname === 'pgastos.capacitatu.com';

// En Apps Nativas (Capacitor) o Desarrollo: desregistrar Service Worker y PURGAR cualquier Caché del WebView
if ('serviceWorker' in navigator && (isNativeApp || !isPWAProduction)) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
      console.log('🧹 Service Worker desregistrado (App Nativa o Desarrollo)');
    });
  });
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
        console.log('🧹 Caché antigua eliminada:', name);
      });
    });
  }
}

// Registrar Service Worker para PWA (únicamente en el dominio web oficial de producción y NUNCA en app nativa)
if (isPWAProduction && !isNativeApp && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('✅ Service Worker registrado (PWA):', registration);
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('🔄 Nueva versión del Service Worker disponible');
            }
          });
        });
      })
      .catch((error) => {
        console.error('❌ Error al registrar Service Worker:', error);
      });
  });
}
